import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser, hasPermission, homeForRole } from "../lib/auth";

export function AccessRoute({ permission, children }: { permission: string | string[]; children: ReactNode }) {
  const auth = useQuery({ queryKey: ["auth", "me"], queryFn: getCurrentUser, staleTime: 60_000 });
  if (auth.isPending) return <div className="page-loader" aria-label="Проверяем доступ"><span /></div>;
  if (!auth.data || auth.data === "bootstrap") return children;
  if (hasPermission(auth.data, permission)) return children;
  return <Navigate to={homeForRole(auth.data.role)} replace />;
}

export function RoleHome() {
  const auth = useQuery({ queryKey: ["auth", "me"], queryFn: getCurrentUser, staleTime: 60_000 });
  if (auth.isPending) return <div className="page-loader" aria-label="Открываем рабочее место"><span /></div>;
  return <Navigate to={auth.data && auth.data !== "bootstrap" ? homeForRole(auth.data.role) : "/dashboard"} replace />;
}
